export enum DeviceTypesEnum {
  'desktop' = 'desktop',
  'mobile' = 'mobile',
  'phone' = 'phone',
  'tablet' = 'tablet',
  'UNKNOWN' = 'UNKNOWN',
}

export type DeviceTypesEnumValues = keyof typeof DeviceTypesEnum;
